import {DiDate} from 'app/blocks/util/di-date';
import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {IQuestionCollection, QuestionCollection} from 'app/blocks/model/check-list-category.model';
import {ILocationPoint, LocationPoint} from 'app/blocks/model/location-point/location-point.model';
import {IQuestion, Question} from 'app/blocks/model/question.model';

export interface ISurvey extends IBaseEntity {
    id?: number;
    name?: string;
    questions?: IQuestion[];
    categories?: IQuestionCollection[];
    enabled?: boolean;
    timeOfSurvey?: string;
    surveyType?: string;
    locationPoints?: ILocationPoint[];
    locationPointIds?: number[];
    hardStopSurvey?: boolean;
    locationPointCount?: number;
}

export class Survey extends BaseEntity implements ISurvey {
    public id?: number;
    public name?: string;
    public questions?: Question[];
    public categories?: QuestionCollection[];
    public enabled?: boolean;
    public timeOfSurvey?: string;
    public surveyType?: string;
    public locationPoints?: LocationPoint[];
    public locationPointIds?: number[];
    public hardStopSurvey?: boolean;
    public locationPointCount?: number;

    constructor(survey?) {
        super();
        if (survey) {
            this.id = survey.id;
            this.name = survey.name;
            this.questions = survey.questions;
            this.categories = survey.categories;
            this.enabled = survey.enabled !== undefined ? survey.enabled : true;
            this.timeOfSurvey = survey.timeOfSurvey;
            this.surveyType = survey.surveyType;
            this.locationPoints = survey.locationPoints || [];
            this.locationPointIds = survey.locationPointIds || [];
            this.hardStopSurvey = survey.hardStopSurvey;
            this.locationPointCount = survey.locationPointCount;
        } else {
            this.locationPoints = [];
            this.locationPointIds = [];
            this.enabled = true;
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): Survey {
        return new Survey(this);
    }
}
